module.exports = __webpack_public_path__ + "assets/media/morning.e6262d04.mp3";